const formatFormHelperText = (required, helperText, errorMsg) => {
  return `${required ? '' : '(Opcional) '} ${errorMsg || helperText || ''}` || ' '
}

export default formatFormHelperText
